// @ts-nocheck
import { Component, Inject, Injector, AfterViewInit, PLATFORM_ID, ViewEncapsulation, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { AbstractComponent } from '../../abstract.component';
import { LoyaltyService } from '@shopping-angular-components/loyalty'
import { LandingModel } from "../../../model/landingModel";
import { UtilsService } from 'projects/common/services/utils.service';
import { UpaTrackingData } from 'projects/common/services/upa.service';

declare var window: any;

@Component({
  selector: 'loyalty-switch',
  template: `
    <div [id]='containerUniqueId'></div>
  `,
  styleUrls: [],
  encapsulation: ViewEncapsulation.None
})
export class LoyaltySwitchComponent extends AbstractComponent implements AfterViewInit, OnDestroy {
  @Input() containerUniqueId: string;
  @Input() disableContainerStyles: boolean;  //shadow + border
  @Input() upaTrackingData: UpaTrackingData;
  @Output() clickedLoyaltySwitch: EventEmitter<boolean> = new EventEmitter();

  locale: string;
  landingModel: LandingModel;
  loyaltySwitchState: boolean;

  constructor(
    injector: Injector,
    @Inject(PLATFORM_ID) private platformId: string,
    private loyaltyService: LoyaltyService,
    private utilsService: UtilsService,
  ) {
    super(injector);
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {

      window.addEventListener('loyaltyModeChanged', this.onSwitchToggled, true);

      this.loyaltySwitchState = this.utilsService.getCookieValue("redemption_switch") == "redemption";
      this.clickedLoyaltySwitch.emit(this.loyaltySwitchState);

      let pageviewId = window.upaData?.pageview_id;
      let product = window.upaData?.pr;
      const landingModel = this.landingModelService.getLandingModel();
      this.locale = landingModel.language + '-' + landingModel.country.toUpperCase();

      this.loyaltyService.initLoyaltyRedemptionSwitch(
        this.locale,
        {
          pr: product,
          fl: this.flow,
          flow_type: 'landing',
          pageview_id: pageviewId
        },
        this.disableContainerStyles,
        this.containerUniqueId
        // TODO para cuando actualicemos la dependencia
        //,this.isMobile ? LoyaltySwitchDesign.COLLAPSED : (['flights', 'hotels'].includes(product) ? LoyaltySwitchDesign.HORIZONTAL : undefined)
      );
    }
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      window.removeEventListener('loyaltyModeChanged', this.onSwitchToggled, true);
    }
  }

  onSwitchToggled = (event: CustomEvent) => {
    this.loyaltySwitchState = event.detail?.mode === 'redemption';
    
    this.upaService.trackClickTopic({
      label: `loyalty-switch-toggle-${this.loyaltySwitchState ? "ON" : "OFF"}`,
      ...this.upaTrackingData
    });
    this.clickedLoyaltySwitch.emit(this.loyaltySwitchState);
  }

  getModuleId(): string {
    return "loyalty-switch";
  }

}
